<template>
    <div>
        <div v-bind:class="ifLoading" class="loader">
            <TheSpinner />
        </div>
        <div class="p-3 md:p-10" v-if="loading">
            <ul class="participantgrid">
                <li :key="sportartItem.ID" v-for="sportartItem in items" class="uppercase text-primary-red pb-2" >
                    <router-link v-bind:to="sportartItem.route">
                        <img v-bind:src="sportartItem.img" />
                        <div class="participant">
                            <the-language :de="sportartItem.name_de" :en="sportartItem.name_en" /><br />
                            <the-language :de="sportartItem.land_de" :en="sportartItem.land_en" />
                        </div>

                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import TheTitle from "../TheTitle";
    import TheLanguage from "../TheLanguage";
    import TheSpinner from "../TheSpinner"
    import TheTextView from "../TheTextView";
    import ergebnis from "../match/ergebnis";
    import teams from "../match/teams"
    import TheYouTube from "../TheYouTubeStandAlone";

    export default {
        name: 'teilnehmer',
        components: {
            TheSpinner,
            TheLanguage,
            TheTitle,
            TheTextView,
            ergebnis,
            teams,
            TheYouTube
        },
        data(){
            return{
                currentFilter: 'ALL',
                loading: false,
                items: []
            }
        },
        created: function(){
            const baseURI = 'https://api.pgsi2020.de/api/file/teilnehmerlist.json'
            this.$http.get(baseURI)
                .then((result) => {
                    this.items = result.data,
                        this.loading = true
                })
        },
        computed: {
            ifLoading() {
                if(this.loading){
                    return 'loaded';
                }else{
                    return 'isLoading';
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .participantgrid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        -ms-grid-columns:  1fr 1fr;
        @screen md{
            grid-template-columns: 1fr 1fr 1fr;
            -ms-grid-columns:  1fr 1fr 1fr;
        }
        grid-gap: 20px;
        align-items: end;
        justify-items: end;
    }
    .participantgrid li {
        max-width: 100%;
        position: relative;
    }

    .participant{
    //text-shadow: -25px 16px 0px rgba(248, 178, 52, 0.8);

        text-shadow:
                0 1px #f8b234,
                -1px 0 #c93c26,
                -1px 2px #f8b234,
                -2px 1px #c93c26,
                -2px 3px #f8b234,
                -3px 2px #c93c26,
                -3px 4px #f8b234,
                -4px 3px #c93c26,
                -4px 5px #f8b234,
                -5px 4px #c93c26,
                -5px 6px #f8b234,
                -6px 5px #c93c26,
                -6px 7px #f8b234,
                -7px 6px #c93c26,
                -7px 8px #f8b234,
                -8px 7px #c93c26;
    //mix-blend-mode: luminosity;

        color: #FFF;
        font-family: 'Briberra';
        width: 100%;
        position: absolute;
        bottom: 25%;
        left: 0px;
        padding: 10px 0 10px 10px;
        text-align: center;
        font-size: 1rem;
        opacity: 1;
        transition: all ease-in-out 1s;
        @screen md {
            font-size: 3rem;
            padding: 20px 0 20px 20px;
        }
    }
</style>
